import { LeftOutlined } from '@ant-design/icons';
import { Link, To } from 'react-router-dom';
import { useTranslation } from 'translations/hooks';

import Button from 'ui/button';

import styles from './index.module.scss';

interface PreviousPageButton {
  to: To;
  label: string;
  className?: string;
  isMobile?: boolean;
}

export const PreviousPageButton = ({
  to,
  label,
  className,
  isMobile,
}: PreviousPageButton) => {
  const { t } = useTranslation();

  return (
    <Link to={to} className={isMobile ? styles.mobileBackButton : undefined}>
      <Button
        className={className}
        type={isMobile ? 'link' : 'default'}
        icon={isMobile ? <LeftOutlined /> : null}
        iconPosition="start"
      >
        {!isMobile ? t(label) : null}
      </Button>
    </Link>
  );
};
